import loadService, {IImage} from './loadService';
import {_sia} from '../configuration/index.config';
const {DEFAULT_RADIUS, DEFAULT_ANCHORS_RADIUS, DEFAULT_LINE_PRESS, DEFAULT_LINE_POINT, STROKE_STYLE, Alpha} = _sia.canvasConfig;

interface points{
    x:number,
    y:number,
    color:string,
    isInEdit?:boolean,
    label?:string,
    attribute?:string,
    isPointInPath?: (x, y) => boolean

} // points type

interface rects{
    pointLeftTop:{ x:number, y:number},
    pointRightBottom:{ x:number, y:number},
    pointRightTop:{ x:number, y:number},
    pointLeftBottom:{ x:number, y:number},
    width:number,
    height:number,
    label?:string,
    attribute?:string,
    color:string
} // rectangle type


class CanvasServiceOld {
    public canvas: HTMLCanvasElement | null=null;
    private ctx: CanvasRenderingContext2D|null =null;
    private pointRadius = 7;
    private anchorRadius = 6; // radius of the rectangle anchors
    private mousePress = false;
    public indexPointPress = -1; // if point was chosen
    public indexSegment = -1;
    public indexRect = -1; // if rectangle was chosen
    public direction = '';
    public rectMove:{x:number, y:number, inResize?:number} = {x: -1, y: -1};
    public pointList: points[] = [];
    public rectList : rects[] = [];
    public canvasImg:HTMLImageElement|null=null;
    public scale = 1;
    public scalePoint = 1;
    public originX = 0;
    public segmentList:points[][] = [];
    public isShowLabels = false;
    public cropsPictures:any[] = []; // !important - this is the array of the data on the canvas
    public isInCopCutMode = false;
    public indexCrop = -1;
    public isInSyntheticMode = false;
    public isInCropMode = false;
    public cropsImages:{data:any, width:number, height:number, isAllow?: boolean, name:string}[] = []; // !important - this is the array of the data the image that was cuted
    public isInArsenalMode = true;
    public projectName = '';
    public imageDimension:{width:number, height:number} = {width: 0, height: 0}
    public sendToServer:any = null

    /**
     * addCanvas - add image to canvas on the first render
     * @param canvasRef - reference of canvas (React ref)
     * @param width - canvas width
     * @param height - canvas height
     * @param img - base64
     */
    // eslint-disable-next-line no-async-promise-executor
    addCanvas= (canvasRef: HTMLCanvasElement | null, width: string, height: string, img: IImage | null) => new Promise<string>(async (resolve) => {
        this.clearCanvas();
        this.canvas = canvasRef;
        if (this.canvas !== null) {
            this.ctx = !this.ctx ? this.canvas!.getContext('2d') : this.ctx;
            this.canvas!.width = +width;
            this.canvas!.height = +height;
            this.canvasImg = new Image();
            this.canvasImg.src = img!.src;
        }
        resolve('ok');
    })

    /**
     * changePic - change image of canvas
     * @param dataUrl - base64
     */
    changePic = (dataUrl) => {
        this.canvasImg = new Image();
        this!.canvasImg!.src = dataUrl;
        this.canvasImg.onload = () => this.drawAll();
    }

    /**
     * clearCanvas - clear canvas  image + clear array
     * @param isFromLastImage - if last image clear the view
     */
    clearCanvas = (isFromLastImage = false) => {
        this.pointList.splice(0, this.pointList.length);
        this.rectList.splice(0, this.rectList.length);
        this.segmentList.splice(0, this.segmentList.length);
        isFromLastImage && this.ctx && this.ctx!.clearRect(0, 0, this.canvas!.width, this.canvas!.height);
    }

    /**
     * addCropsPictures - add to crop pictures (the crops on the canvas) a new crop
     * @param index - the image index
     * @param x - position of user x
     * @param y - position of user y
     */
    addCropsPictures = (index, x, y) => {
        const imageData = this.cropsImages[index];

        this.cropsPictures.push({width: imageData.width, height: imageData.height, positionX: x, positionY: y, indexImage: index});
        this.indexCrop = this.cropsPictures.length - 1;
        this.drawAll();
    }

    getCopyImage = () => {
        const tmpCanvas:any = document.createElement('canvas');

        tmpCanvas.width = this.canvas!.width;
        tmpCanvas.height = this.canvas!.height;
        const ctx2 = tmpCanvas.getContext('2d');

        ctx2.drawImage(this.canvasImg, 0, 0, this.canvas!.width, this.canvas!.height);

        return [ctx2, tmpCanvas];
    }

    /**
     * getResizedCanvas - this the crop from the original image!!
     * @param width - UI width
     * @param height - UI height
     * @param x - UI x
     * @param y - UI y
     */
    getResizedCanvas = (width, height, x, y) => {
        const scaleX:number = this.canvasImg!.width / this.canvas!.width;
        const scaleY:number = this.canvasImg!.height / this.canvas!.height;
        const tmpCanvas:any = document.createElement('canvas');

        tmpCanvas.width = Math.ceil(width * scaleX);
        tmpCanvas.height = Math.ceil(height * scaleY);
        const ctx2 = tmpCanvas.getContext('2d');
        const img:any = this.canvasImg;

        ctx2!.drawImage(
            img,
            Math.ceil(x * scaleX),
            Math.ceil(y * scaleY),
            Math.ceil(width * scaleX),
            Math.ceil(height * scaleY),
            0,
            0,
            Math.ceil(width * scaleX),
            Math.ceil(height * scaleY),
        );

        return [tmpCanvas!.toDataURL('image/png'), tmpCanvas];
    }

    /**
     * setCropsImagesFromServer - set the crop images array (data from server)
     * @param imageData - base64
     * @param name - patch name
     */
    setCropsImagesFromServer = (imageData, name) => {
        const newImage = new Image();

        newImage.src = imageData;
        newImage.onload = () => this.cropsImages.push({data: newImage, width: newImage!.width, height: newImage!.height, isAllow: true, name});
    };

    /**
     * setCropsImagesFirstTime - set Corps Pictures with the crop image
     * @param width - UI width
     * @param height - UI height
     * @param x - UI x
     * @param y - UI y
     */
    setCropsImagesFirstTime = (width, height, x, y) => {
        this.rectList.splice(0, this.rectList.length);

        const [imageData, tmpCanvas] = this.getResizedCanvas(width, height, x, y);
        const newImage:any = new Image();

        newImage.src = imageData;
        this.cropsImages.push({data: newImage, width, height, isAllow: false, name: `${this.projectName}_${parseInt(`${new Date().getTime() / 1000}`, 10)}`});
        tmpCanvas.remove();
        this.sendToServer('copy');
    };

    /**
     * setCropsImages - setCropsImages from other script
     * @param cropsImages - ref
     * @param sendToServer - send to server function
     * @param projectName - project name
     */
    setCropsImages = (cropsImages, sendToServer, projectName) => {
        this.cropsImages = cropsImages;
        this.sendToServer = sendToServer;
        this.projectName = projectName;
    }

    changeShowLabels = (isShowLabels = false) => this.isShowLabels = isShowLabels;

    /**
     * setShowLabels - set Show Labels if user wants to show labels (shape tag in canvas)
     */
    setShowLabels = () => {
        this.isShowLabels = !this.isShowLabels;
        this.drawAll();
    }

    /**
     * getRectCoordinates - get rect coordinates
     * @param index - witch rect is it
     */
    getRectCoordinates = (index) => {
        const thisRect = this.rectList[index];

        return [{x: thisRect.pointLeftTop.x, y: thisRect.pointLeftTop.y}, {x: thisRect.pointRightBottom.x, y: thisRect.pointRightBottom.y }];
    }

    /**
     * removeEvents - clear canvas to default mode
     */
    removeEvents=() => {
        this.canvas = null;
        this.ctx = null;
        this.mousePress = false;
        this.indexRect = -1;
        this.indexPointPress = -1;
        this.indexSegment = -1;
        this.indexCrop = -1;
        this.direction = '';
        this.isInSyntheticMode = false;
        this.pointList.splice(0, this.pointList.length);
        this.rectList.splice(0, this.rectList.length);
        this.segmentList.splice(0, this.segmentList.length);
    }

    /**
     * touchMoveCalculate - calculate x,y of user
     * @param e
     */
    touchMoveCalculate=(e:MouseEvent) => {
        const rect = this.canvas!.getBoundingClientRect();
        const mouseX = parseInt(`${(e.clientX - rect.left) / (rect.right - rect.left) * this.canvas!.width}`, 10);
        const mouseY = parseInt(`${(e.clientY - rect.top) / (rect.bottom - rect.top) * this.canvas!.height}`, 10);

        return {mouseX, mouseY};
    }

    /**
     * pointInCircle - find if user pressed on circle (it could be point/ anchor of rectangle)
     */
    pointInCircle=(mouseX:number, mouseY:number, pointX:number, pointY:number, radius:number) => {
        const distanceSquared = (mouseX - pointX) * (mouseX - pointX) + (mouseY - pointY) * (mouseY - pointY);

        return distanceSquared <= radius * radius;
    }

    /**
     * findIfInBorderX - find if x in canvas width
     */
    findIfInBorderX=(x:number, radius:number, rectWidth = this.canvas!.width) => x > radius && x < rectWidth - radius

    /**
     * findIfInBorderY - find if y in canvas height
     */
    findIfInBorderY=(y:number, radius:number, rectHeight = this.canvas!.height) => y > radius && y < rectHeight - radius

    /**
     * roundRect - draw rect with round borders
     * @param x -  x start
     * @param y - y start
     * @param width - width
     * @param height - height
     * @param radius - radius
     */
    roundRect = (x, y, width, height, radius) => {
        this.ctx!.moveTo(x + radius, y);
        this.ctx!.lineTo(x + width - radius, y);
        this.ctx!.quadraticCurveTo(x + width, y, x + width, y + radius);
        this.ctx!.lineTo(x + width, y + height - radius);
        this.ctx!.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        this.ctx!.lineTo(x + radius, y + height);
        this.ctx!.quadraticCurveTo(x, y + height, x, y + height - radius);
        this.ctx!.lineTo(x, y + radius);
        this.ctx!.quadraticCurveTo(x, y, x + radius, y);
        this.ctx!.fill();
    }

    /**
     * changeShapeProperties - when user change the label/ attribute value
     * @param value - label/ attribute value
     * @param type - shape type
     * @param index - index of the shape
     * @param key - label/ attribute
     */
    changeShapeProperties = (value, type, index, key) => {
        type.toLowerCase() === 'point' && (this.pointList[index][key] = value);
        type.toLocaleString() === 'box' && (this.rectList[index][key] = value);
        type.toLocaleString() === 'segment' && (this.segmentList[index][0][key] = value);

        this.drawAll();
    }

    /**
     * pickColor - pick color
     * @param x - user x
     * @param y - user y
     */
    pickColor = (x, y) : string => {
        const [ctx, tmpCanvas] = this.getCopyImage();
        const data = ctx!.getImageData(x, y, 1, 1).data;

        tmpCanvas.remove();

        return [].slice.call(data, 0, 3).join();
    }

    /**
     * setDrawLabel - add new label (shape tag)
     * @param text - text
     * @param shape - witch shape
     * @param type - witch shape type
     * @param isInEditMode - edit mode will not draw
     */
    setDrawLabel = (text, shape, type, isInEditMode = false) => {
        if (this.isShowLabels && !(isInEditMode)) {
            this.ctx!.font = '10pt Courier';
            const metrics = this.ctx!.measureText(text);

            if (type === 'rect') {
                this.drawLabel(text, (metrics.width + 20), shape.pointLeftTop.x + (shape.width / 2) - ((metrics.width + 20) / 2), shape.pointLeftTop.y - 25, shape.color);
            } else {
                this.drawLabel(text, (metrics.width + 20), shape.x - ((metrics.width + 20) / 2), shape.y - (25 + this.pointRadius), shape.color);
            }
        }
    }

    /**
     * drawLabel - draw label (shape tag)
     * @param text
     * @param width
     * @param x
     * @param y
     * @param color
     */
    drawLabel = (text, width, x, y, color) => {
        let newX = x;

        if (x + width > this.canvas!.width) {
            newX = x - (width / 2);
        } else if (x - (width / 2) < 0) {
            newX = 0;
        }

        const newY = y - 25 < 0 ? 0 : y;

        this.ctx!.beginPath();
        this.ctx!.fillStyle = color;
        this.roundRect(newX, newY, width, 25, 4);
        this.ctx!.textAlign = 'center';
        this.ctx!.textBaseline = 'middle';
        this.ctx!.fillStyle = color === 'rgb(0, 0, 0)' ? 'white' : 'black';
        this.ctx!.fillText(text, newX + (width / 2), newY + (25 / 2));
        this.ctx?.closePath();

    }

    /**
     * drawAll - this function draw all the elements that in the current state
     * !important! - if you have a new shape please add it here
     * @param mouseX - user x
     * @param mouseY - user y
     * @param pointEditMode - if point in edit (point index)
     * @param rectEditPoint - if rect in edit (rect index)
     */
    drawAll=(mouseX = -100, mouseY = -100, pointEditMode = -1, rectEditPoint = -1) => {
        if (!this.ctx) {
            return;
        }

        this.ctx!.save();
        const currentTransform = this.ctx!.getTransform();

        this.ctx!.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx!.clearRect(0, 0, this.canvas!.width, this.canvas!.height);
        this.ctx!.setTransform(currentTransform);
        this.ctx!.drawImage(this.canvasImg!, 0, 0, this.canvas!.width, this.canvas!.height);
        this.isInSyntheticMode && !this.isInArsenalMode && this.cropsPictures.forEach((imgData, index) => {
            const diffX = mouseX - this.rectMove.x;
            const diffY = mouseY - this.rectMove.y;

            // this.rectList.splice(0, this.rectList.length);

            if (this.rectMove.inResize === index) {
                const width = Math.abs(imgData.positionX - mouseX);
                const height = Math.abs(imgData.positionY - mouseY);

                if (width > 5 && height > 5 && width <= this.canvas!.width && height <= this.canvas!.height) {
                    imgData.width = width;
                    imgData.height = height;
                }

            } else if (this.rectMove.x > -1000 && this.findIfInBorderX(imgData.positionX + diffX, 0 && this.findIfInBorderY(imgData.positionY + diffY, 0) &&
                this.findIfInBorderX(imgData.width + diffX, 0) && this.findIfInBorderY(imgData.height + diffY, 0)) && this.indexCrop === index) {
                const positionX = imgData.positionX + diffX;
                const positionY = imgData.positionY + diffY;

                if (positionX >= 0 && positionX + imgData.width <= this.canvas!.width && positionY >= 0 && positionY + imgData.height <= this.canvas!.height) {
                    imgData.positionX = positionX;
                    imgData.positionY = positionY;
                    this.rectMove.x = mouseX;
                    this.rectMove.y = mouseY;
                    this.ctx!.strokeStyle = STROKE_STYLE;
                    this.ctx!.lineWidth = 2;
                    this.ctx!.globalAlpha = 1;
                }

            }
            const image:any = this.cropsImages[imgData.indexImage].data;

            this.ctx!.globalAlpha = 0.7;
            this.ctx!.drawImage(image, imgData.positionX, imgData.positionY, imgData.width, imgData.height);
            this.ctx!.globalAlpha = 1;
            if (this.isInCropMode || !this.isInSyntheticMode) {
                this.indexCrop === index && this.ctx!.strokeRect(imgData.positionX, imgData.positionY, imgData.width, imgData.height);
            }

        });
        ((this.indexCrop === -1 && (!this.isInArsenalMode && this.isInSyntheticMode)) || (this.isInArsenalMode && this.isInCropMode) || !this.isInSyntheticMode) && this.rectList.forEach((rect, index) => {
            if (index === this.indexRect && this.direction.length > 0) {
                if (this.findIfInBorderX(mouseX, 0) && this.findIfInBorderY(mouseY, 0)) {
                    this.resizeRect(mouseX, mouseY, rect);
                }
                this.drawRectangle(
                    rect.pointLeftTop.x,
                    rect.pointLeftTop.y,
                    rect.width,
                    rect.height,
                    rect.color,
                    false
                );
            } else if (index === this.indexRect && this.direction.length === 0) {
                const diffX = mouseX - this.rectMove.x;
                const diffY = mouseY - this.rectMove.y;

                if (this.findIfInBorderX(rect.pointLeftTop.x + diffX, 0) && this.findIfInBorderY(rect.pointLeftTop.y + diffY, 0) &&
                    this.findIfInBorderX(rect.pointRightBottom.x + diffX, 0) && this.findIfInBorderY(rect.pointRightBottom.y + diffY, 0)) {
                    rect.pointLeftTop.x += diffX;
                    rect.pointLeftTop.y += diffY;
                    this.updateAnchorsPoints(rect);
                    this.rectMove.x = mouseX;
                    this.rectMove.y = mouseY;
                }
                this.drawRectangle(
                    rect.pointLeftTop.x,
                    rect.pointLeftTop.y,
                    rect.width,
                    rect.height,
                    rect.color,
                    false
                );
            } else {
                if (this.isInSyntheticMode && this.isInCropMode && this.isInArsenalMode && this.indexRect === -1) {
                    this.setCropsImagesFirstTime(rect.width, rect.height, rect.pointLeftTop.x, rect.pointLeftTop.y);
                } else {
                    this.drawRectangle(
                        rect.pointLeftTop.x,
                        rect.pointLeftTop.y,
                        rect.width,
                        rect.height,
                        rect.color,
                        false
                    );
                }

                this.setDrawLabel(`${rect.label} ${rect.attribute}`, rect, 'rect', rectEditPoint === index);

            }
            rectEditPoint === index && this.drawAnchors(rect.pointLeftTop.x, rect.pointLeftTop.y, rect.width, rect.height, rect.color);
        });
        this.segmentList.forEach((segmentPoints, segmentPointsIndex) => {
            this.drawPolygon(segmentPoints, segmentPointsIndex, mouseX, mouseY);

        });
        this.pointList.forEach((point, index) => {
            if (pointEditMode === index) {
                let x = point.x;
                let y = point.y;

                if (index === this.indexPointPress && this.findIfInBorderX(mouseX, this.pointRadius) && this.findIfInBorderY(mouseY, this.pointRadius)) {
                    x = mouseX;
                    y = mouseY;
                }
                this.drawCircle(x, y, point.color, false, point.label, point.attribute);
                this.pointPress(x, y);
                point.x = x;
                point.y = y;
            } else {
                this.setDrawLabel(`${point.label} ${point.attribute}`, point, 'point');
                this.drawCircle(point.x, point.y, point.color, false, point.label, point.attribute);

            }
        });
        this.ctx!.restore();
    }

    /**
     * drawPolygon - draw polygon (segment)
     * @param segmentPoints - all the polygon points
     * @param segmentPointsIndex - which segment is it
     * @param mouseX - mouse event x
     * @param mouseY - mouse event y
     */
    drawPolygon = (segmentPoints, segmentPointsIndex, mouseX = -100, mouseY = -100) => {
        const firstPoint = segmentPoints[0];

        if (firstPoint) {
            const path = new Path2D();

            this.ctx!.beginPath();
            segmentPoints.length > 1 && path.moveTo(firstPoint.x, firstPoint.y);
            this.ctx!.globalAlpha = Alpha.LIGHT;
            this.ctx!.strokeStyle = STROKE_STYLE;
            this.ctx!.lineWidth = 2;
            segmentPoints.forEach((point) => {
                this.ctx!.fillStyle = point.color;
                path.lineTo(point.x, point.y);
                if (this.indexSegment === segmentPointsIndex) {
                    if (point.isInEdit) {
                        if (mouseX !== -100) {
                            point.x = mouseX;
                            point.y = mouseY;
                        }
                    }
                    path.arc(point.x, point.y, this.pointRadius, 0, 2 * Math.PI, true);
                }
            });
            path.closePath();
            this.ctx!.fill(path);
            this.ctx!.globalAlpha = 1;
            this.ctx!.stroke(path);
            segmentPoints.isPointInPath = (x, y) => this.ctx!.isPointInPath(path, x, y);
            this.setDrawLabel(`${segmentPoints[0].label} ${segmentPoints[0].attribute}`, segmentPoints[1], 'segment', this.indexSegment === segmentPointsIndex);
        }
    }

    /**
     * mouseMove - when user move on canvas
     * @param e - touch event
     * @param pointEditMode
     * @param pointEditMode - if point in edit (point index)
     * @param rectEditPoint - if rect in edit (rect index)
     */
    mouseMove=(e:MouseEvent, pointEditMode = -1, rectEditPoint = -1) => {
        if (this.mousePress && this.canvas) {
            const {mouseX, mouseY} = this.touchMoveCalculate(e);

            this.drawAll(mouseX, mouseY, pointEditMode, rectEditPoint);
        }
    }

    /**
     * deleteSegment - delete segment (polygon)
     * @param index - which segment is it
     */
    deleteSegment = (index) => {
        this.segmentList.splice(index, 1);
        this.drawAll();
    }

    /**
     * deleteCropUi - delete the crop from the canvas (on the big picture)
     */
    deleteCropUi = () => {
        this.cropsPictures.splice(this.indexCrop, 1);
        this.indexCrop = -1;
        this.drawAll();
    }

    /**
     * deleteCrop - delete crop from arsenal
     * @param index - index of the crop
     */
    deleteCrop = (index) => {
        this.cropsPictures.splice(index, 1);
        this.cropsImages.splice(index, 1);
        this.indexCrop = -1;
        this.drawAll();
    }

    /**
     * deletePoint - delete point from view
     * @param index - point index
     */
    deletePoint=(index) => {
        this.pointList.splice(index, 1);
        this.drawAll();
    }

    /**
     * setColorSynthetic - when user return to color mode in synthetic
     * @param rectList - the new rectList
     */
    setColorSynthetic = (rectList) => {
        this.rectList.splice(0, this.rectList.length);
        rectList.forEach((rect) => this.rectList.push(rect));
        this.indexCrop = -1;
        this.isInCropMode = false;
    }

    /**
     * deleteRect - delete rect from view
     * @param index - rect index
     */
    deleteRect=(index) => {
        this.rectList.splice(index, 1);
        this.drawAll();
    }

    /**
     * updateAnchorsPoints - update the new vertices of the rect
     * @param rect - the rect object
     */
    updateAnchorsPoints = (rect) => {
        rect.pointRightTop.x = rect.pointLeftTop.x + rect.width;
        rect.pointRightTop.y = rect.pointLeftTop.y;
        rect.pointLeftBottom.x = rect.pointLeftTop.x;
        rect.pointLeftBottom.y = rect.pointLeftTop.y + rect.height;
        rect.pointRightBottom.x = rect.pointLeftTop.x + rect.width;
        rect.pointRightBottom.y = rect.pointLeftTop.y + rect.height;
    }

    /**
     * resizeRect - !important! - the main anchor x,y is pointLeftTop all others anchors will go by his change
     * @param mouseX - user x
     * @param mouseY - user y
     * @param rect - the rect object
     */
    resizeRect=(mouseX:number, mouseY:number, rect:rects) => {
        if (this.direction === 'leftTop') {
            rect.width += rect.pointLeftTop.x - mouseX;
            rect.height += rect.pointLeftTop.y - mouseY;
            rect.pointLeftTop.x = mouseX;
            rect.pointLeftTop.y = mouseY;
        } else if (this.direction === 'rightTop') {
            rect.width = Math.abs(rect.pointLeftTop.x - mouseX);
            rect.height += rect.pointLeftTop.y - mouseY;
            rect.pointLeftTop.y = mouseY;
        } else if (this.direction === 'leftBottom') {
            rect.width += rect.pointLeftTop.x - mouseX;
            rect.height = Math.abs(rect.pointLeftTop.y - mouseY);
            rect.pointLeftTop.x = mouseX;
        } else if (this.direction === 'rightBottom') {
            rect.width = Math.abs(rect.pointLeftTop.x - mouseX);
            rect.height = Math.abs(rect.pointLeftTop.y - mouseY);
        }
        this.updateAnchorsPoints(rect);
    }

    /**
     * isPointInPoly - find if point (click event) is inside the polygon (segment)
     * @param pt - point (x, y)
     */
    isPointInPoly = (pt): [isPress: boolean, segmentIndex: number] => {
        let isPress = false;
        let segmentIndex = 0;

        this.segmentList.forEach((poly:any, index) => {
            if (poly.isPointInPath(pt.x, pt.y)) {
                isPress = true;
                segmentIndex = index;
            }
        });


        return [isPress, segmentIndex];
    }

    /**
     * clickOnCropImage - when user click on crop image in the canvas
     * @param index - crop index
     * @param mouseX - user x
     * @param mouseY - user y
     */
    clickOnCropImage = (index, mouseX, mouseY) => {
        this.indexCrop = index;
        this.rectMove = {x: mouseX, y: mouseY, inResize: -1};
        this.drawAll();
    }

    /**
     * mouseDown - when user press on canvas
     * @param e - touch event
     * @param pointEdit - point edit object (if it is point)
     * @param rectEdit - rect edit object (if rect in edit)
     * @param segmentEdit - segment edit object (if rect in edit)
     * @param type - if type exist
     */
    // eslint-disable-next-line max-len,complexity
    mouseDown=(e:MouseEvent, pointEdit:{isNew?:boolean, color?:string, pointIndex: number, label?:string, attribute?:string } = {pointIndex: -1}, rectEdit:{isNew?:boolean, color?:string, rectIndex : number, label?:string, attribute?:string } = {rectIndex: -1}, segmentEdit:{isNew?:boolean, color?:string, segmentIndex : number, label?:string, attribute?:string } = {segmentIndex: -1}, type = 'point'):boolean => {
        this.mousePress = true;
        const {mouseX, mouseY} = this.touchMoveCalculate(e);
        let isNewPressed = true;

        if (type.toLowerCase() === 'point') {
            this.pointList.forEach((point, index) => {
                const {x, y} = point;

                if (this.pointInCircle(mouseX, mouseY, x, y, this.pointRadius)) {
                    this.indexPointPress = index;
                    if (pointEdit.pointIndex > -1 && pointEdit.pointIndex === index) {
                        this.pointPress(x, y);
                    } else if (pointEdit.pointIndex === -1 && rectEdit.rectIndex === -1) {
                        isNewPressed = false;
                    }
                }
            });// find if point in press mode
        } else if (type.toLowerCase() === 'box') {
            let isInCropPosition = false;

            this.isInSyntheticMode && !this.isInArsenalMode && this.isInCropMode && this.cropsPictures.forEach((imgData, index) => {
                if (mouseX >= imgData.positionX &&
                    mouseX <= imgData.positionX + imgData.width &&
                    mouseY <= imgData.positionY + imgData.height &&
                    mouseY >= imgData.positionY && (this.indexCrop === -1 || index === this.indexCrop) && !this.pointInCircle(mouseX, mouseY, imgData.positionX + imgData.width, imgData.positionY + imgData.height, 3)) {
                    this.clickOnCropImage(index, mouseX, mouseY);
                    isInCropPosition = true;
                } else if (!isInCropPosition && this.pointInCircle(mouseX, mouseY, imgData.positionX + imgData.width, imgData.positionY + imgData.height, 3)) {
                    this.rectMove = {x: -1000, y: -1000, inResize: index};
                }
            });
            ((this.indexCrop === -1 && !this.isInCropMode) || !this.isInSyntheticMode) && this.rectList.forEach((rect, index) => {
                const rectArray = Object.entries(rect);

                rectArray.forEach(
                    ([key, point]) => {
                        if (key.includes('point') && this.pointInCircle(mouseX, mouseY, point.x, point.y, this.anchorRadius + 20)) {

                            isNewPressed = false;
                            this.indexRect = index;
                            const removePoint = key.replace('point', '');

                            this.direction = removePoint.charAt(0).toLocaleLowerCase() + removePoint.slice(1);
                        }
                    }
                );
                if (mouseX >= rect.pointLeftTop.x &&
                    mouseX <= rect.pointRightTop.x &&
                    mouseY <= rect.pointLeftBottom.y &&
                    mouseY >= rect.pointLeftTop.y && (rectEdit.rectIndex === -1 || index === rectEdit.rectIndex)) {
                    this.drawAnchors(rect.pointLeftTop.x, rect.pointLeftTop.y, rect.width, rect.height, rect.color);
                    this.indexRect = index;
                    this.direction = '';
                    this.rectMove = {x: mouseX, y: mouseY};
                    isNewPressed = false;
                }

            });// find if rectangle in press mode
        } else if (type.toLowerCase() === 'segment') {
            if (this.segmentList.length === 0) {
                isNewPressed = true;
            } else if (this.indexSegment === -1) {
                const [isPress, indexSegment] = this.isPointInPoly({x: mouseX, y: mouseY});

                isNewPressed = !isPress;
                this.indexSegment = indexSegment;
            }
        }

        if (rectEdit.rectIndex === -1) {
            if (pointEdit.isNew && isNewPressed) {
                if (this.isInSyntheticMode) {
                    if (!((this.isInArsenalMode && this.isInCropMode) || (!this.isInArsenalMode && !this.isInCropMode))) {
                        return false;
                    }
                }
                pointEdit.color && this.drawCircle(mouseX, mouseY, pointEdit.color, true, pointEdit.label, pointEdit.attribute);
                this.pointPress(mouseX, mouseY);
                this.indexPointPress = this.pointList.length - 1;
            } else if (rectEdit.isNew && isNewPressed && this.indexCrop === -1 && rectEdit.color) {
                if (this.isInSyntheticMode) {
                    if (!((this.isInArsenalMode && this.isInCropMode) || (!this.isInArsenalMode && !this.isInCropMode))) {
                        return false;
                    }
                }
                rectEdit.color && this.drawRectangle(mouseX, mouseY, 10, 10, rectEdit.color, true, rectEdit.label, rectEdit.attribute);
                rectEdit.color && this.drawAnchors(mouseX, mouseY, 10, 10, rectEdit.color);
                this.direction = 'rightBottom';
                this.indexRect = this.rectList.length - 1;
            } else if (segmentEdit.isNew && isNewPressed) {
                this.segmentList.push([]);
                this.indexSegment = this.segmentList.length - 1;
                this.segmentEdit(mouseX, mouseY, segmentEdit.color, this.segmentList[this.indexSegment], segmentEdit.label, segmentEdit.attribute);
            }
        }

        return isNewPressed;

    }

    /**
     * pointPress - this function draw the 4 lines when edit point
     * @param x
     * @param y
     * @param isFromSegment - if came from segment need a different approach
     */
    pointPress=(x:number, y:number, isFromSegment = false) => {
        !isFromSegment && this.ctx!.beginPath();
        this.ctx!.lineWidth = DEFAULT_LINE_PRESS * (1 / this.scalePoint);
        this.ctx!.strokeStyle = STROKE_STYLE;
        this.ctx!.moveTo(x + this.pointRadius, y);
        this.ctx!.lineTo(x + 15 * (1 / this.scalePoint), y);
        this.ctx!.moveTo(x - this.pointRadius, y);
        this.ctx!.lineTo(x - 15 * (1 / this.scalePoint), y);
        this.ctx!.moveTo(x, y + this.pointRadius);
        this.ctx!.lineTo(x, y + 15 * (1 / this.scalePoint));
        this.ctx!.moveTo(x, y - this.pointRadius);
        this.ctx!.lineTo(x, y - 15 * (1 / this.scalePoint));
        this.ctx!.stroke();
        !isFromSegment && this.ctx!.closePath();
    }

    /**
     * stopEdit - when user stop edit shape
     */
    stopEdit=() => {
        this.mousePress = false;
        this.indexPointPress = -1;
        this.indexRect = -1;
        this.indexSegment = -1;
        this.direction = '';
        this.indexCrop = -1;
        this.isInCopCutMode = false;
        this.rectMove = {x: -1000, y: -1000, inResize: -1};
        this.setSegmentPointsEdit();
        this.drawAll();
    }

    /**
     * leavePress - when user leave the press
     */
    leavePress=() => {
        if (this.mousePress) {
            this.mousePress = false;
            this.indexPointPress = -1;
            this.indexRect = -1;
            this.direction = '';
            this.setSegmentPointsEdit();
        }
    }

    /**
     * drawCircle - this circle is the point shape
     * @param x
     * @param y
     * @param color
     * @param isNewPoint
     * @param label value
     * @param attribute value
     */
    drawCircle=(x = this.canvas!.width / 2, y = this.canvas!.height / 2, color:string, isNewPoint = true, label = '', attribute = '') => {
        this.ctx!.beginPath();
        this.ctx!.arc(x, y, this.pointRadius, 0, 2 * Math.PI, true);
        this.ctx!.fillStyle = color;
        this.ctx!.globalAlpha = Alpha.DEFAULT;
        this.ctx!.fill();
        this.ctx!.globalAlpha = 1;
        this.ctx!.strokeStyle = STROKE_STYLE;
        this.ctx!.lineWidth = DEFAULT_LINE_POINT * (1 / this.scalePoint);
        this.ctx!.stroke();
        this.ctx!.closePath();
        isNewPoint && this.pointList.push({x, y, color, label, attribute});
    }

    /**
     * drawCircleAnchor - this is the anchor circle
     * @param x
     * @param y
     * @param color
     */
    // TODO: combine the drawCircle with drawCircleAnchor
    drawCircleAnchor=(x:number, y:number, color:string) => {
        this.anchorRadius = DEFAULT_ANCHORS_RADIUS * (1 / this.scalePoint);
        this.ctx!.beginPath();
        this.ctx!.arc(x, y, this.anchorRadius, 0, 2 * Math.PI, true);
        this.ctx!.fillStyle = color;
        this.ctx!.globalAlpha = Alpha.DEFAULT;
        this.ctx!.fill();
        this.ctx!.globalAlpha = 1;
        this.ctx!.strokeStyle = STROKE_STYLE;
        this.ctx!.lineWidth = 2;
        this.ctx!.stroke();
        this.ctx!.closePath();
    }

    /**
     * drawAnchors - draw anchors of rect
     * @param rectX - top left x
     * @param rectY - top left y
     * @param rectWidth - rect width
     * @param rectHeight - rect height
     * @param color - the anchors colors
     */
    drawAnchors=(rectX:number, rectY:number, rectWidth:number, rectHeight:number, color:string) => {
        this.drawCircleAnchor(rectX, rectY, color);
        this.drawCircleAnchor(rectX + rectWidth, rectY, color);
        this.drawCircleAnchor(rectX + rectWidth, rectY + rectHeight, color);
        this.drawCircleAnchor(rectX, rectY + rectHeight, color);
    }

    /**
     * drawRectangle - draw rectangle
     */
    drawRectangle=(x = 30, y = 30, width = 100, height = 100, color:string, isNewRect = true, label = '', attribute = '') => {
        this.ctx!.beginPath();
        this.ctx!.fillStyle = color;
        this.ctx!.globalAlpha = Alpha.LIGHT;
        this.ctx!.fillRect(x, y, width, height);
        this.ctx!.strokeStyle = STROKE_STYLE;
        this.ctx!.lineWidth = 2;
        this.ctx!.globalAlpha = 1;
        this.ctx!.strokeRect(x, y, width, height);
        this.ctx!.closePath();
        isNewRect && this.rectList.push({
            pointLeftTop: {x, y},
            pointRightBottom: {x: x + width, y: y + height},
            pointRightTop: {x: x + width, y},
            pointLeftBottom: {x, y: y + height},
            width,
            height,
            color,
            label,
            attribute
        });
    }

    /**
     * setSegmentPointsEdit - set the points of segment to be not in edit mode
     */
    setSegmentPointsEdit = () => this.segmentList[this.indexSegment] && this.segmentList[this.indexSegment].forEach((point) => point.isInEdit = false);

    /**
     * segmentEdit - create new segment point
     * @param x - x
     * @param y - y
     * @param color - color
     * @param segmentPoints - ref of segment that need to edit
     * @param label value
     * @param attribute value
     */
    segmentEdit =(x = this.canvas!.width / 2, y = this.canvas!.height / 2, color?:string, segmentPoints?:any, label = '', attribute = '') => {
        const pointIndex = segmentPoints.findIndex((point) => this.pointInCircle(x, y, point.x, point.y, this.pointRadius));

        if (pointIndex === -1) {
            const segmentObject = segmentPoints.length === 0 ? {x, y, color, isInEdit: true, label, attribute} : {x, y, color, isInEdit: true};

            segmentPoints.push(segmentObject);
            this.setSegmentPointsEdit();
        } else {
            segmentPoints[pointIndex].isInEdit = true;
        }
        this.drawAll();
    }

    /**
     * changeColor - change shape color
     * @param color - new color
     * @param type - shape type
     * @param index - shape index
     */
    changeColor = (color, type, index) => {
        type.toLowerCase() === 'point' && (this.pointList[index].color = color);
        type.toLocaleString() === 'box' && (this.rectList[index].color = color);
        type.toLocaleString() === 'segment' && (this.segmentList[index].forEach((segment) => segment.color = color));

        this.drawAll();
    }

    /**
     * onZoomChange - when user zoom in and out
     */
    onZoomChange = (scale) => {
        this.scalePoint = scale;
        this.pointRadius = DEFAULT_RADIUS * (1 / this.scalePoint);
        this.rectMove = {x: -1000, y: -1000, inResize: -1};
    }

    getRatio(index, containerRef) {
        return new Promise<any>((resolve) => {
            const widthContainer = containerRef && containerRef.current && (containerRef.current.clientWidth);
            const heightContainer = containerRef && containerRef.current && (containerRef.current.clientHeight);
            const img = loadService!.allDataFromLocal![index] ? loadService!.allDataFromLocal![index]!.img : null;

            const setSize = () => loadService.aspectRatio(widthContainer, heightContainer, img);

            if (img) {
                if (img.width === 0 && img.height === 0) {
                    const image = new Image();

                    image.src = img.src;
                    image.onload = () => {
                        img.width = image.width;
                        img.height = image.height;
                        resolve({imageDimension: setSize(), img});
                    };
                } else {
                    resolve({imageDimension: setSize(), img});
                }
            }
        });

    }
}

export default new CanvasServiceOld();
